import { t } from 'i18next';
import type { ErrorStrategy } from '../types';

export const constStrategy: ErrorStrategy = ({ instancePath, params }) => {
  // implies a $data reference or otherwise set allowedValue in the Schema
  const { allowedValue } = params;
  return {
    path: instancePath,
    message: t('ErrorStrategyConst', { allowedValue }),
  };
};
